import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { HOME_FAQS } from '@/constants/homeFaq';
import { FUNNEL_EVENTS, trackFunnelEvent } from '@/services/FunnelAnalytics';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  const toggleQuestion = (index: number, topic: string) => {
    const isOpening = openIndex !== index;
    setOpenIndex(isOpening ? index : null);

    if (isOpening) {
      trackFunnelEvent(FUNNEL_EVENTS.homepageFaqOpened, { topic });
    }
  };

  const continueToCreate = () => {
    const source = 'faq_bottom_cta';
    trackFunnelEvent(FUNNEL_EVENTS.homepageCtaClicked, { source });
    navigate(`/create?source=${source}`);
  };

  return (
    <section id="faq" className="section-shell relative py-20">
      <div className="container relative mx-auto px-6 max-w-3xl">
        <div className="mb-10">
          <h2 className="section-title text-foreground">
            Questions <span className="text-premium">fréquentes</span>
          </h2>
        </div>

        <div className="space-y-3">
          {HOME_FAQS.map((faq, index) => (
            <div
              key={faq.topic}
              className="rounded-[1.6rem] border border-white/60 bg-[linear-gradient(180deg,rgba(255,255,255,0.82),rgba(247,239,233,0.92))] shadow-card overflow-hidden"
            >
              <button
                className="w-full text-left px-6 py-5 flex items-center justify-between gap-4"
                onClick={() => toggleQuestion(index, faq.topic)}
                aria-expanded={openIndex === index}
              >
                <span className="font-semibold text-foreground text-[0.95rem] leading-6">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`h-5 w-5 text-foreground/40 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 text-sm text-foreground/65 leading-7">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-[1.8rem] border border-primary/15 bg-white/70 p-6 text-center shadow-card backdrop-blur-sm sm:p-8">
          <p className="font-display text-2xl text-foreground sm:text-3xl">
            Prêt à visualiser votre photo en tableau ?
          </p>
          <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-foreground/65 sm:text-base">
            Importez votre photo, comparez les styles et choisissez votre support dans le parcours de création.
          </p>
          <button
            type="button"
            className="mt-5 inline-flex min-h-12 items-center justify-center gap-2 rounded-full bg-primary px-7 py-3 font-semibold text-primary-foreground shadow-glow transition-premium hover:-translate-y-0.5 hover:brightness-105"
            onClick={continueToCreate}
          >
            Créer mon tableau
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
